var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3761",
    "data-name": "Rectangle 3761",
    width: 24,
    height: 24,
    transform: "translate(60 479)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4731",
    "data-name": "Mask Group 4731",
    transform: "translate(-60 -479)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7597",
    "data-name": "Group 7597",
    transform: "translate(62.579 481.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7596",
    "data-name": "Group 7596",
    transform: "translate(0.422 2.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8203",
    "data-name": "Path 8203",
    d: "M19.5,31.694V37.3a2.334,2.334,0,0,1-2.334,2.334H3.834A2.334,2.334,0,0,1,1.5,37.3V31.694",
    transform: "translate(-1.5 -25.806)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_789",
    "data-name": "Line 789",
    y2: 10.027,
    transform: "translate(9)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8204",
    "data-name": "Path 8204",
    d: "M29.132,34.162l-3.873,3.873-3.873-3.873",
    transform: "translate(-16.259 -27.637)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVender);
export default __webpack_public_path__ + "static/media/vender.d96ea5e0801df4f96f829740807e6790.svg";
export { ForwardRef as ReactComponent };